<template>
  <figure
    class="kim"
    :style="`
      background-image: url(${require('@/assets/kim/kim-'+ mood + '.svg')});
      background-color: ${color};
      background-position: ${returnPosition}`"
  >
  </figure>
</template>

<script>
export default {
  name: 'Kim',
  props: {
    mood: {
      type: String,
      default: 'neutral'
    },
    color: {
      type: String,
      default: '#B9008D'
    }
  },
  computed: {
    returnPosition () {
      let position = ''
      switch (this.mood) {
        case 'neutral': position = 'left bottom'; break
        case 'playful': position = 'left bottom'; break
      }
      return position
    }
  }
}
</script>

<style lang="scss" scoped>
.kim {
  width: 100%;
  height: auto;
  min-height: 300px;
  overflow: hidden;
  padding: 0;
  margin: 0;
  background: {
    // image: url(~@/assets/kim/kim.svg);
    repeat: no-repeat;
    size: cover;
    // color: #B9008D; // green
  }
  // border: 1rem solid #B9E857;
  // background: {
  //   image: url(~@/assets/backgrounds/lightning.svg);
  //   repeat: repeat;
  //   position: center center;
  //   color: #B9E857; // green
  // }
}
</style>
